export const help = {
  "help.title": "Suji Help Center",
  "help.subtitle": "Find answers, guides and get the help you need",
  "help.search_placeholder": "Search in help...",
  "help.quick_actions": "Quick actions",
  "help.browse_category": "Browse by category",
  "help.contact_support": "Contact support",
  "help.get_help": "Get personalized help",
  "help.live_chat": "Live chat",
  "help.immediate_assistance": "Immediate assistance",
  "help.faq": "FAQ",
  "help.frequent_questions": "Frequently asked questions",
  "help.video_tutorials": "Video tutorials",
  "help.visual_guides": "Visual guides",
  "help.popular_articles": "Popular articles",
  "help.read_time": "min",
  "help.read_article": "Read article",
  "help.view_all_articles": "View all articles",
  "help.need_more_help": "Need more help?",
  "help.support_available": "Our support team is available to help you with all your questions"
};

export default help;
